import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from '../components/Icon';
import { LogoMark } from '../components/LogoMark';
import { useEngineStore } from '../state/engineStore';

type NavEntry = { to: string; label: string; icon: IconName };

const FLIGHT_NAV: NavEntry[] = [
  { to: '/wizard', label: 'LOP Procedure', icon: 'wand' },
  { to: '/monitor', label: 'Live Monitor', icon: 'gauge' },
  { to: '/runup', label: 'Run-up Assistant', icon: 'spark' },
];

const ENGINE_NAV: NavEntry[] = [
  { to: '/troubleshoot', label: 'Troubleshoot', icon: 'alert' },
  { to: '/settings', label: 'Settings', icon: 'cog' },
];

function NavItem({ entry }: { entry: NavEntry }) {
  return (
    <NavLink
      to={entry.to}
      className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
    >
      <Icon name={entry.icon} size={16} />
      <span style={{ flex: 1 }}>{entry.label}</span>
      <span className="dot" />
    </NavLink>
  );
}

export function Sidebar() {
  const { config } = useEngineStore();
  return (
    <aside className="sidebar">
      <div className="brand">
        <LogoMark size={34} />
        <div>
          <div className="brand-name">Lean Assist</div>
          <div className="brand-sub">{config.cylinderCount}-cyl · session only</div>
        </div>
      </div>

      <div className="nav-section-label">Flight</div>
      {FLIGHT_NAV.map((n) => (
        <NavItem key={n.to} entry={n} />
      ))}

      <div className="nav-section-label">Engine</div>
      {ENGINE_NAV.map((n) => (
        <NavItem key={n.to} entry={n} />
      ))}

      <div style={{ marginTop: 'auto' }}>
        <div className="card card-ghost" style={{ padding: 12 }}>
          <div className="row" style={{ marginBottom: 8 }}>
            <span className="chip">
              <span className="dot" /> Advisory only
            </span>
          </div>
          <div style={{ fontSize: 12, color: 'var(--ink-2)', lineHeight: 1.5 }}>
            Not a certified instrument. Always cross-check your engine monitor.
          </div>
        </div>
      </div>
    </aside>
  );
}
